import React, { useEffect, useState } from "react";
import "../Style.css";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { getTemplates, selectTemplate } from "../services/templateService";
import { getUserInfo, getCurrentCompanyId } from "../utils/auth";
import CryptoJS from "crypto-js";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";  
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";

export default function TemplateSelector({ userId }) {

  const navigate = useNavigate();

  const [templates, setTemplates] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [showDetail, setShowDetail] = useState(false);
const [currentTemplate,setCurrentTemplate]=useState("");
const [currentTemplateId, setCurrentTemplateId] = useState("");
const [currentTemplateName, setCurrentTemplateName] = useState("");

  const handleProductClose = () => {
    setShowDetail(false);
  };

  const loadTemplates = async () => {
    if (templates.length == 0) {
      setCompanyId(getCurrentCompanyId());
      const res = await getTemplates();
      setTemplates(res.data);
    }
  };

  const handleSelect = async (templateId, templateName) => {
    try {
      const token = localStorage.getItem("token");
      await selectTemplate(userId, templateId, token);
      setSelectedId(templateId);
      toast.success("Template - " + templateName + " has been selected, successfully!");
      
      setTimeout(
        function () {
          window.location.reload(true);
        }.bind(this),
        2000
      );
    } catch (error) {
      console.error("Error selecting template:", error);
      alert("Failed to select template.");
    }
  };

  const showTemplateDetail = (urlDetail, id, name) => {
    setCurrentTemplate(urlDetail);
    setCurrentTemplateId(id);
    setCurrentTemplateName(name);
    setShowDetail(true);
  };

  useEffect(() => {
    console.log("showDetail ", showDetail);
    loadTemplates();
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <div className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <main className="container">
              <header className="d-flex flex-column flex-md-row align-items-start justify-content-between mb-3">
                <div>
                  <h3 className="page-title">Select Your Website Template</h3>
                  <p className="lead">
                    Choose a template preview and click <strong>Select</strong>{" "}
                    to apply it to your website. Click Preview for a live view.
                  </p>
                </div>
              </header>
              {/* Grid */}
              <div className="row page-grid g-3">
                {/* Template Card (repeat for each template) */}
                {/* Example items - update data-preview & data-template-id as needed */}

                {templates.map((tpl, index) => (
                  <div className="col-12 col-sm-6 col-lg-4">
                    <div
                      className="template-card h-100"
                      data-template-id="68e10ad39e73b06b49481696"
                    >
                      <div className="card-top">
                        <div>
                          <div className="template-title">
                            <span>
                              Template {index + 1}: {tpl.name}
                            </span>
                            {/* <span className="badge badge-type bg-primary text-white ms-2"> */}
                            <span className="badge badge-type bg-info text-white ms-2 Portfolio"></span>
                          </div>
                          <small className="text-muted">
                            {tpl.description}
                          </small>
                        </div>
                      </div>

                      <div className="card-body">
                        <div className="preview-wrap">
                          {/* <img
                          src="https://image.thum.io/get/https://www.apple.com"
                          alt="Apple Thumbnail"
                          width="300"
                        /> */}
                          <div
                            style={{
                              width: "300px",
                              height: "200px",
                              overflow: "hidden",
                              border: "1px solid #ccc",
                            }}
                          >
                            <iframe
                              src={`${tpl.previewUrl}/${companyId}`}
                              style={{
                                width: "1200px",
                                height: "800px",
                                transform: "scale(0.25)",
                                transformOrigin: "0 0",
                                border: "0",
                              }}
                            ></iframe>
                          </div>
                        </div>

                        <div className="card-actions">
                          <div className="d-flex gap-2">
                            <button
                              onClick={(e) =>
                                showTemplateDetail(
                                  `${tpl.previewUrl}/${companyId}`,
                                  tpl.id,
                                  tpl.name
                                )
                              }
                              className="btn preview-btn btn-outline-primary btn-sm"
                            >
                              <i className="bi bi-eye"></i> Preview
                            </button>

                            {tpl.isSelected ? (
                              <button className="btn select-btn btn-success btn-sm">
                                <i className="bi bi-check-circle"></i> Selected
                              </button>
                            ) : (
                              <button
                                className="btn select-btn btn-primary btn-sm"
                                data-template-id={tpl.id}
                                onClick={() => handleSelect(tpl.id, tpl.name)}
                              >
                                <i className="bi bi-check-circle"></i> Select
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>{" "}
            </main>
          </div>
        </div>
      </div>
      <Modal
        show={showDetail}
        onHide={handleProductClose}
        className="modal-dialog modal-xl modal-fullscreen-sm-down"
      >
        <Modal.Header>
          <Modal.Title>Template Preview</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleProductClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <iframe
            id="previewFrame"
            className="w-100"
            style={{ height: "70vh", border: "0" }}
            title="Template live preview"
            src={currentTemplate}
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            id="applyFromPreview"
            className="btn btn-success"
            onClick={() => handleSelect(currentTemplateId, currentTemplateName)}
          >
            Select this template
          </Button>
          <Button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={handleProductClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Footer />
    </>
  );
}